<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm8>
      <v-alert color="error" v-model="errors.length" class="errors">
        <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
      </v-alert>
      <v-form v-on:submit.prevent="setPassword()" v-if="isEmailValidated">
        <v-alert class="mb-3" type="info" :value="true">
          Votre mot de passe doit contenir au moins 6 caractères
        </v-alert>
        <v-text-field
          solo
          label="Mot de passe"
          v-model="password"
          required
          type="password"
          class="mb-4"
        ></v-text-field>
        <v-text-field
          solo
          label="Confirmation de mot de passe"
          v-model="repeatPassword"
          required
          type="password"
          class="mb-4"
        ></v-text-field>
        <v-layout align-center justify-center>
          <v-btn type="submit" round large color="info">
            Accéder à Weview
          </v-btn>
        </v-layout>
      </v-form>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name : `setPassword`,
  data () {
    return {
      isEmailValidated : false,
      password         : ``,
      repeatPassword   : ``,
    };
  },
  props : [
    `registrationId`,
  ],
  computed : {
    ...mapState({
      errors : state => state.uiState.errors,
    }),
  },
  methods : {
    setPassword () {
      const errors = [];
      if (this.password !== this.repeatPassword) {
        errors.push(`Les 2 mots de passe ne correspondent pas`);
      } else if (this.password.length < 6) {
        errors.push(`Votre mot de passe doit contenir au moins 6 caractères`);
      }

      this.$store.dispatch(`setErrors`, errors);

      if (errors.length) { return; }

      this.$store.dispatch(`setPassword`, {
        registrationId : this.registrationId,
        password       : this.password,
      })
      .then(res => this.$store.dispatch(`successPassword`, {
        jwt : res.data,
        registrationId : this.registrationId,
      }))
      .catch(e => this.$store.dispatch(`serverError`, e));
    },
  },
  created () {
    this.$store.dispatch(`setPageTitle`, `Validation de votre adresse email . . .`);
    this.$store.dispatch(`setPageSubtitle`, ``);
  },
  mounted () {
    this.$store.dispatch(`validateEmailForRegistration`, this.registrationId)
    .then(() => {
      this.isEmailValidated = true;
      this.$store.dispatch(`isLoading`, false);
      this.$store.dispatch(`setPageTitle`, `Votre adresse email est validée !`);
      this.$store.dispatch(`setPageSubtitle`, `Choisissez maintenant un mot de passe`);
    })
    .catch(e => this.$store.dispatch(`serverError`, e));
  },
};
</script>

<style lang="scss" scoped>
.success-icon {
  font-size: 40px;
}
</style>



// WEBPACK FOOTER //
// SetPassword.vue?f2ef1dca